import React, { useEffect, useState } from "react";
import { ComponentLoader } from "./LoadingFallback";

const DEFAULT_TIMEOUT_MS = 10000;

const DefaultAuthFallback = () => (
  <div className="mx-auto my-6 max-w-md rounded-lg border border-gray-200 bg-white p-4 text-center shadow-sm dark:border-gray-700 dark:bg-gray-800">
    <p className="m-0 text-sm text-gray-600 dark:text-gray-200">
      We are still checking your session.
    </p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="mt-3 rounded-lg border border-[#2563EB] bg-[#2563EB] px-3 py-1.5 text-sm font-medium text-white transition-colors hover:bg-[#2563EB] dark:border-[#2563EB] dark:bg-[#2563EB] dark:hover:bg-[#2563EB]"
    >
      Retry
    </button>
  </div>
);

const AuthReadyGuard = ({
  isPending,
  children,
  timeoutMs = DEFAULT_TIMEOUT_MS,
  loader,
  fallback,
}) => {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!isPending) {
      setTimedOut(false);
      return;
    }

    const timeoutId = setTimeout(() => setTimedOut(true), timeoutMs);
    return () => clearTimeout(timeoutId);
  }, [isPending, timeoutMs]);

  if (!isPending) {
    return <>{children}</>;
  }

  if (!timedOut) {
    return loader || <ComponentLoader />;
  }

  return fallback || <DefaultAuthFallback />;
};

export default AuthReadyGuard;
